import {
	CHAT_AI_PLANS_REFERENCES,
	CURSEDUCA_PLANS_REFERENCES
} from '../constants/plansReferences';
import { withSessionFragment } from '../../../../utils/memberEntryUrl';

type Input = {
	planReference: string;
	receipt: string;
	value: number;
	accessToken: string;
	platformUrl?: string;
	isComercial: boolean;
	sellerToken?: string | null;
};

type Output = {
	url: string;
	isOnboarding: boolean;
};

// Shared with the Pix waiting screen, where confirmation arrives from the
// `bill_paid` webhook instead of the submit.
export const resolveSubscriptionRedirect = ({
	planReference,
	receipt,
	value,
	accessToken,
	platformUrl,
	isComercial,
	sellerToken
}: Input): Output => {
	const selfCheckout = CURSEDUCA_PLANS_REFERENCES[planReference];

	if (selfCheckout) {
		const originParam = isComercial ? '&origin=COMERCIAL' : '';
		// ?token=base64(saleId;sellerEmail): opaque here, decoded by the
		// onboarding, so a malformed one cannot break checkout.
		const tokenParam = sellerToken
			? `&token=${encodeURIComponent(sellerToken)}`
			: '';
		const onboardingUrl =
			process.env.REACT_APP_ONBOARDING_URL ??
			'https://onboarding.curseduca.com';

		return {
			// value: the onboarding fires the Meta Pixel Purchase and has no
			// other source for the amount paid.
			url: `${onboardingUrl}/wizard?receipt=${receipt}${originParam}${tokenParam}&value=${value}`,
			isOnboarding: true
		};
	}

	const aiPlan = CHAT_AI_PLANS_REFERENCES[planReference];

	if (aiPlan) {
		return {
			url: `https://goai.curseduca.com/?plan=${aiPlan}&receipt=${receipt}`,
			isOnboarding: false
		};
	}

	// `receipt` = referência da ASSINATURA. A página de obrigado só tinha a do
	// plano e mostrava o preço de tabela — com cupom, desconto à vista ou juros
	// o valor exibido (e o enviado ao pixel) não era o cobrado.
	// Só o `receipt` na query: o token vai no fragmento (ver memberEntryUrl).
	const queryParams = new URLSearchParams({ receipt });

	// 🔴 `platformUrl` vem de `customization?.url` e pode ser undefined quando a
	// personalização do checkout não carrega — o que acontece justamente durante
	// uma indisponibilidade. Sem guarda, o template interpolava a STRING
	// "undefined" e o comprador era levado para uma URL inexistente:
	//
	//   http://localhost:3001/p/recurring/undefined/p/recurring/thanks/VGVzdGU...
	//
	// Medido no teste de incidente de 08/09. A origem atual é o fallback certo:
	// é de onde o checkout está sendo servido, então a rota de obrigado existe lá.
	const baseUrl = platformUrl || window.location.origin;

	return {
		url: withSessionFragment(
			`${baseUrl}/p/recurring/thanks/${planReference}?${queryParams.toString()}`,
			accessToken
		),
		isOnboarding: false
	};
};
